// extracted by mini-css-extract-plugin
export default {"textCenter":"common_textCenter__iROdg","preWrap":"common_preWrap__AsY10","pointer":"common_pointer__2Jfi7","fullWidth":"common_fullWidth__cTDIG"};